export class SearchSectionItems {
  id!: number;
  key!: string;
  title!: string;
  icon!: string;
}
